module.exports = __webpack_public_path__ + "assets/249b3f450b2f9ff309e89e0184c8a701.jpg";